module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/placement.540e67d3.svg";